import React, { useEffect } from "react";
import UserScreenWindow from "../Components/UserScreenWindow";
import {
  queryAllDocsByFieldSnap,
  getDocDataSnap,
} from "../../../utils/firebase/Firebase.utils";
import { useSelector } from "react-redux";
import BillingCard from "./BillingCard";
import { Link } from "react-router-dom";
import {
  FaReceipt,
  FaCheckCircle,
  FaClock,
  FaFileInvoiceDollar,
} from "react-icons/fa";

function Bills() {
  const currentUser = useSelector((state) => state.userObject);

  const [billings, setBillings] = React.useState([]);
  const [identifiers, setIdentifiers] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [activeLink, setActiveLink] = React.useState("Unpaid");

  useEffect(() => {
    const getIdentifiers = async () => {
      const data = await getDocDataSnap("users", currentUser.uid, (data) => {
        setIdentifiers(data.linkedIdentifiers);
      });
    };
    getIdentifiers();
  }, []);

  useEffect(() => {
    const getBillings = async () => {
      const allBillings = [];
      for (const identifier of identifiers) {
        const data = await queryAllDocsByFieldSnap(
          "billings",
          "identifier",
          "==",
          identifier,
          (data) => {
            allBillings.push(...data);
            setBillings(allBillings);
            setIsLoading(false);
          }
        );
      }
    };

    if (identifiers.length > 0) {
      getBillings();
    }
  }, [identifiers]);

  const links = [
    { name: "Unpaid", icon: <FaClock className="mr-2" /> },
    { name: "Paid", icon: <FaCheckCircle className="mr-2" /> },
  ];

  const currentItems = billings.filter((billing) => {
    if (activeLink === "Unpaid") {
      return billing.status !== "paid";
    } else {
      return billing.status === "paid";
    }
  });

  return (
    <UserScreenWindow label="Bills">
      <div className="w-full mx-auto px-4 max-w-4xl">
        <div className="flex items-center justify-between mb-6 bg-[#363062]/5 p-4 rounded-lg">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[#363062] rounded-lg">
              <FaFileInvoiceDollar className="text-white text-base" />
            </div>
            <div>
              <h1 className="text-sm font-medium text-[#363062]">
                Billing Details
              </h1>
              <p className="text-xs text-gray-500">
                Manage your payments and invoices
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center mb-6">
          <div
            className="inline-flex rounded-lg shadow-sm w-full flex-grow bg-gray-50"
            role="group"
          >
            {links.map((link, index) => (
              <button
                key={link.name}
                className={`flex-1 px-3 py-2 text-xs font-medium ${
                  index === 0
                    ? "rounded-l-lg"
                    : index === links.length - 1
                    ? "rounded-r-lg"
                    : ""
                } flex items-center justify-center gap-2 transition-all ${
                  activeLink === link.name
                    ? "bg-[#363062] text-white shadow-sm"
                    : "bg-transparent text-[#363062] hover:bg-[#363062]/5"
                }`}
                onClick={() => setActiveLink(link.name)}
              >
                {link.icon}
                <span>{link.name}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-3">
          {currentItems.map((billing, index) => (
            <Link
              to={
                billing.status === "paid"
                  ? `/payment-posted/${billing.id}`
                  : `/billing-details/${billing.id}`
              }
              key={index}
              className="block transition-all hover:transform hover:translate-y-[-2px] hover:shadow-md"
            >
              <BillingCard billing={billing} />
            </Link>
          ))}

          {currentItems.length === 0 &&
            !isLoading &&
            activeLink === "Unpaid" && (
              <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-100">
                <div className="p-3 bg-[#8FCD00]/10 rounded-full w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <FaCheckCircle className="text-[#8FCD00] text-lg" />
                </div>
                <h3 className="text-sm font-medium text-[#363062] mb-1">
                  All Caught Up!
                </h3>
                <p className="text-xs text-gray-500">
                  You have no pending bills at the moment
                </p>
              </div>
            )}
        </div>
      </div>
    </UserScreenWindow>
  );
}

export default Bills;